type ReportFilterPayload = {
    deviceIds?: string[];
    fileName?: string;
    from?: number | string | null;
    groupIds?: string[];
    reportName?: string;
    to?: number | string | null;
};

type MonthlyReportPagePayload = {
    page?: number;
    searchKey?: string | null;
    size?: number;
};

type BuildMonthlyReportRequestArgs = {
    deviceId?: string;
    groupId?: string;
    pagePayload: MonthlyReportPagePayload;
    reportFilters?: ReportFilterPayload;
};

export type MonthlyReportRequestPayload = MonthlyReportPagePayload & {
    deviceIds?: string[];
    from?: string;
    groupIds?: string[];
    reportName?: string;
    to?: string;
};

export const toEpochSeconds = (value: number | string | null | undefined): string | undefined => {
    if (value === null || value === undefined || value === '') return undefined;

    const timestamp = Number(value);
    if (!Number.isFinite(timestamp) || timestamp < 0) return undefined;

    return String(Math.floor(timestamp > 1_000_000_000_000 ? timestamp / 1000 : timestamp));
};

export const buildMonthlyReportRequest = ({
    deviceId,
    groupId,
    pagePayload,
    reportFilters = {},
}: BuildMonthlyReportRequestArgs): MonthlyReportRequestPayload => {
    const selectedGroupIds = reportFilters.groupIds?.length ? reportFilters.groupIds : groupId ? [groupId] : undefined;
    const selectedDeviceIds = deviceId ? [deviceId] : reportFilters.deviceIds;
    const from = toEpochSeconds(reportFilters.from);
    const to = toEpochSeconds(reportFilters.to);
    const reportName = reportFilters.reportName ?? reportFilters.fileName ?? undefined;

    return {
        ...(pagePayload.page !== undefined && { page: pagePayload.page }),
        ...(pagePayload.size !== undefined && { size: pagePayload.size }),
        ...(pagePayload.searchKey !== undefined && { searchKey: pagePayload.searchKey }),
        ...(selectedGroupIds?.length && { groupIds: selectedGroupIds }),
        ...(selectedDeviceIds?.length && { deviceIds: selectedDeviceIds }),
        ...(from !== undefined && { from }),
        ...(to !== undefined && { to }),
        ...(reportName && { reportName }),
    };
};
